import type { MatchHudLayout } from "./hud-layout";
import type { MatchHudModel } from "./match-hud-model";

function rectStyle(rectangle: MatchHudLayout["menu"]): React.CSSProperties {
  return {
    left: rectangle.left,
    top: rectangle.top,
    width: rectangle.width,
    height: rectangle.height,
  };
}

export function SemanticHudOverlay({
  layout,
  model,
  onOpenMenu,
  onPauseAi,
  onFastAi,
  onPhaseAction,
}: {
  readonly layout: MatchHudLayout;
  readonly model: MatchHudModel;
  readonly onOpenMenu: () => void;
  readonly onPauseAi: () => void;
  readonly onFastAi: () => void;
  readonly onPhaseAction: () => void;
}) {
  return (
    <section
      className="alpha-semantic-hud"
      aria-label="Match status and controls"
      data-alpha-visible-owner="r3f"
    >
      <p className="sr-only" aria-live="polite">
        {model.statusMessage}
      </p>
      <p className="sr-only" aria-label={`Current phase: ${model.phase}`}>
        {model.phaseSummary}
      </p>
      <div
        className="sr-only"
        aria-label={`Your Kingdom progress${model.ownKingdomComplete ? ", Kingdom Complete" : ""}`}
      />
      <div
        className="sr-only"
        aria-label={`Opponent Kingdom progress${model.opponentKingdomComplete ? ", Kingdom Complete" : ""}`}
      />
      <dl className="sr-only">
        <dt>Turn</dt>
        <dd>{model.turnNumber}</dd>
        <dt>Phase</dt>
        <dd>{model.phase}</dd>
        <dt>Phase objective</dt>
        <dd>{model.phaseSummary}</dd>
        <dt>Food</dt>
        <dd>{model.ownResources.food}</dd>
        <dt>Production</dt>
        <dd>{model.ownResources.production}</dd>
        <dt>Trade</dt>
        <dd>{model.ownResources.trade}</dd>
        <dt>Science</dt>
        <dd>{model.ownResources.science}</dd>
        <dt>Culture</dt>
        <dd>{model.ownResources.culture}</dd>
      </dl>
      <button
        className="alpha-semantic-hud__control"
        type="button"
        aria-label="Open game menu"
        style={rectStyle(layout.menu)}
        onClick={onOpenMenu}
      />
      {model.aiState === "hidden" ? null : (
        <>
          <button
            className="alpha-semantic-hud__control"
            type="button"
            aria-label={model.aiState === "paused" ? "Resume AI" : "Pause AI"}
            style={rectStyle(layout.pauseAi)}
            onClick={onPauseAi}
          />
          <button
            className="alpha-semantic-hud__control"
            type="button"
            aria-label="Fast"
            disabled={model.aiState === "fast" || model.aiState === "paused"}
            style={rectStyle(layout.fastAi)}
            onClick={onFastAi}
          />
        </>
      )}
      {model.phaseActionLabel === null ? null : (
        <button
          className="alpha-semantic-hud__control alpha-semantic-hud__phase-action"
          type="button"
          aria-label={model.phaseActionLabel}
          disabled={!model.phaseActionEnabled}
          style={rectStyle(layout.phaseAction)}
          onClick={onPhaseAction}
        />
      )}
    </section>
  );
}
